import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";

export type EmpresaConvenioInvitadoInputs =
  | "activar"
  | "patron"
  | "tipo"
  | "cantidad";

export const formConfig: FormBuilderConfig<
  EmpresaConvenioInvitadoInputs,
  string
> = {
  inputs: [
    {
      name: "activar",
      label: "Activar para invitados",
      bts: {
        sCol: 3
      }
    },
    {
      name: "patron",
      label: "Patrón de acceso",
      bts: {
        sCol: 3
      }
    },
    {
      name: "tipo",
      label: "Tipo de invitados",
      component: ISelectBuilder,
      bts: {
        sCol: 3
      },
      props: {
        data: [
          { value: "0", label: "Intercambio comercial" },
          { value: "1", label: "Accionistas" },
          { value: "2", label: "Corporativos" }
        ],
        disabled: values => values.activar !== "1"
      }
    },
    {
      name: "cantidad",
      label: "Límite de invitados",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        disabled: values => values.activar !== "1"
      },
      bts: {
        sCol: 3
      }
    }
  ],
  buttons: [],
  validations: {
    activar: {
      required: true
    },
    patron: {
      requiredIfActivo: {
        validator: (value, formValue) => !value && formValue.activar === "1",
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [["activar", "patron", "tipo", "cantidad"]]
};
